import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createKnockoutSchedule,
  updateKnockoutRound
} from "../../../../Config/API/knockout-schedule";
import KnockoutScheduleFormFields from "./KnockoutScheduleFormFields";

function KnockoutScheduleForm() {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    // if state is empty, go back to the previous page
    if (!state && !state?._id) navigate(-1);

    // navigate to matches if schedule round variables are added
    if (state?.scheduleComplete) {
      navigate(`/organizer/event/${state?._id}/knock-out-matches`);
    }
  }, []);

  const createInitialKnockOutSchedule = async () => {
    const payload = { eventId: state?._id };
    const result = await createKnockoutSchedule(payload);
    const data = await result.json();
    if (data?.type !== "success" && data?.message?.toLowerCase()?.includes("already created")) {
      // if initial knockout schedule is already created
      return;
    }
  };

  // call create knockout schedule when schedule page is visited for the first time
  useEffect(() => {
    if (!state?.scheduleComplete) {
      createInitialKnockOutSchedule();
    }
  }, [state?._id]);

  const updateKnockoutScheduleRound = async (values) => {
    const payload = { ...values, currentRound: 1 };
    const response = await updateKnockoutRound(payload);
    const result = await response.json();
    if (result?.scheduledMatches) {
      navigate(`/organizer/event/${state?._id}/knock-out-matches`);
    }
  };

  return (
    <div>
      <KnockoutScheduleFormFields onFormSubmit={updateKnockoutScheduleRound} eventData={state} />
    </div>
  );
}

export default KnockoutScheduleForm;
